import { useEffect } from 'react';
import { useData } from '@/data/Data.hook';

const key = 'isMasked';
const STORAGE_KEY = '__ismsk';
const STORE_IN_STORAGE: boolean = false;
type maskedVariants = 'sideBarMasked' | 'isMasked';

const getFromStorage = (): boolean =>
  !STORE_IN_STORAGE
    ? false
    : sessionStorage.getItem(STORAGE_KEY)?.toString?.()?.toLowerCase?.() !==
      'false';

const setToStorage = (isMasked: boolean): void => {
  if (STORE_IN_STORAGE) sessionStorage.setItem(STORAGE_KEY, `${isMasked}`);
};

export const useIsMasked = (newKey: maskedVariants = key) => {
  const { data: isMasked, setData: setIsMasked } = useData(newKey, {
    initialData: getFromStorage(),
  });

  useEffect(() => setToStorage(isMasked), [isMasked]);

  return { isMasked, setIsMasked, maskedSymbol: '******' };
};
